import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const Heading = styled.h1`
  font-family: ${fonts.heading};
  font-size: ${fonts.size.xl};
  font-weight: ${fonts.weight.bold};
  color: ${colors.fontPrimary};
  text-align: center;
  margin: 0 auto ${space[6]};
  max-width: 100%;

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${fonts.size['3xl']};
    max-width: 75%;
  }
`;

export const Subtitle = styled.span`
  font-weight: ${fonts.weight.normal};
  color: ${colors.fontSecondary};
`;
